export default [
    {
        path: "/dev",
        name: "dev__root__",
        redirect: {
            name: "dev-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "dev",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "dev-index",
                component: () => import("@/views/dev/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/dev/conf",
        name: "dev-conf",
        meta: {
            title: "基础设置",
            icon: "atom",
            parent: "dev",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/conf/global",
        children: [
            {
                path: "global",
                name: "dev-conf-global",
                component: () => import("@/views/dev/conf/index"),
                meta: {
                    title: "全局配置",
                    icon: "global",
                    affix: false,
                },
            },
            {
                path: "static",
                name: "dev-conf-static",
                component: () => import("@/views/dev/conf/static"),
                meta: {
                    title: "静态配置",
                    icon: "config-file",
                    affix: false,
                },
            },
            // {
            //     path: "product",
            //     name: "dev-conf-product",
            //     component: () => import("@/views/dev/conf/product.vue"),
            //     meta: {
            //         title: "产品配置",
            //         icon: "product",
            //         affix: false,
            //     },
            // },
            // {
            //     path: "product-detail/:id(\\d+)?",
            //     name: "dev-conf-product-detail",
            //     hidden: true,
            //     component: () => import("@/views/dev/conf/product-detail.vue"),
            //     meta: {
            //         title: "产品配置详情",
            //         affix: false,
            //         activeMenu: "/dev/conf/product",
            //     },
            // },
        ],
    },
    {
        path: "/dev/platform",
        name: "dev-platform",
        meta: {
            title: "平台设置",
            icon: "platform",
            parent: "dev",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/platform/wx",
        children: [
            {
                path: "wx",
                name: "dev-platform-wx",
                component: () => import("@/views/dev/platform/wx-menus.vue"),
                meta: {
                    title: "微信菜单",
                    icon: "wx",
                    affix: false,
                    permission: "set_wxmp_menu",
                },
            },
        ],
    },
    {
        path: "/dev/mstpl",
        name: "dev-mstpl",
        meta: {
            title: "消息模板",
            icon: "template",
            parent: "dev",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/mstpl/message",
        children: [
            {
                path: "message",
                name: "dev-mstpl-message",
                component: () => import("@/views/dev/mstpl/message-tpl.vue"),
                meta: {
                    title: "私信模板",
                    icon: "template-message",
                    permission: "manage_message_template",
                    affix: false,
                },
            },
            {
                path: "message-detail/:id(\\d+)?",
                name: "dev-mstpl-message-detail",
                hidden: true,
                component: () => import("@/views/dev/mstpl/message-detail.vue"),
                meta: {
                    title: "私信模板详情",
                    permission: "manage_message_template",
                    affix: false,
                    activeMenu: "/dev/mstpl/message",
                },
            },
            {
                path: "email",
                name: "dev-mstpl-email",
                component: () => import("@/views/dev/mstpl/email-tpl.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "template-email",
                    permission: "manage_email_template",
                    affix: false,
                },
            },
            {
                path: "email-detail/:slug([\\w_-]+)?",
                name: "dev-mstpl-email-detail",
                hidden: true,
                component: () => import("@/views/dev/mstpl/email-detail.vue"),
                meta: {
                    title: "邮件模板详情",
                    permission: "manage_email_template",
                    affix: false,
                    activeMenu: "/dev/mstpl/email",
                },
            },
            {
                path: "phone",
                name: "dev-mstpl-phone",
                component: () => import("@/views/dev/mstpl/phone-tpl.vue"),
                meta: {
                    title: "短信模板",
                    icon: "template-phone",
                    permission: "manage_phone_template",
                    affix: false,
                },
            },
            {
                path: "wxmsg",
                name: "dev-mstpl-wxmsg",
                component: () => import("@/views/dev/mstpl/wxmsg-tpl.vue"),
                meta: {
                    title: "微信模板",
                    icon: "template-wxmsg",
                    permission: "manage_wxmsg_template",
                    affix: false,
                },
            },
        ],
    },
     {
        path: "/dev/pm",
        name: "dev-pm",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/pm/i18n",
        meta: {
            title: "项目管理",
            icon: "pm",
            parent: "dev",
            group: 512,
        },
        children: [
            {
                path: "i18n",
                name: "dev-pm-i18n",
                component: () => import("@/views/dev/pm/i18n.vue"),
                meta: {
                    title: "国际化",
                    icon: "i18n",
                },
            },
            {
                path: "i18n-form/:id(\\d+)?",
                name: "dev-pm-i18n-form",
                hidden: true,
                component: () => import("@/views/dev/pm/i18n-form.vue"),
                meta: {
                    title: "国际化",
                    affix: false,
                    activeMenu: "/dev/pm/i18n",
                },
            },
            {
                path: "i18n-detail/:id(\\d+)?",
                name: "dev-pm-i18n-detail",
                hidden: true,
                component: () => import("@/views/dev/pm/i18n-detail.vue"),
                meta: {
                    title: "国际化详情",
                    affix: false,
                    activeMenu: "/dev/pm/i18n",
                },
            },
            {
                path: "spider",
                name: "dev-pm-spider",
                component: () => import("@/views/dev/pm/spider.vue"),
                meta: {
                    title: "自动化",
                    icon: "spider",
                },
            },
        ],
    },
    {
        path: "/dev/account",
        name: "account",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/account/list",
        meta: {
            title: "系统账号",
            icon: "admin",
            parent: "dev",
            group: 256,
        },
        children: [
            {
                path: "list",
                name: "account-list",
                component: () => import("@/views/dev/account/list.vue"),
                meta: {
                    title: "账号配置",
                    icon: "users",
                },
            },
            {
                path: "role",
                name: "account-role",
                component: () => import("@/views/dev/account/role.vue"),
                meta: {
                    title: "角色配置",
                    icon: "role",
                },
            },
            {
                path: "permission",
                name: "account-permission",
                component: () => import("@/views/dev/account/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "permission",
                    group: 512,
                },
            },
        ],
    },
    {
        path: "/dev/system",
        name: "dev-system",
        component: () => import("@/layouts/default.vue"),
        meta: {
            title: "系统管理",
            icon: "manage",
            parent: "dev",
            group: 512,
        },
        redirect: "/dev/system/cdn",
        children: [
            {
                path: "node",
                name: "dev-system-node",
                component: () => import("@/views/dev/system/node.vue"),
                meta: {
                    title: "节点管理",
                    icon: "node",
                    affix: false,
                },
            },
            {
                path: "cdn",
                name: "dev-system-cdn",
                component: () => import("@/views/dev/system/cdn.vue"),
                meta: {
                    title: "内容分发",
                    icon: "cdn",
                    affix: false,
                },
            },
            {
                path: "cache",
                name: "dev-system-cache",
                component: () => import("@/views/dev/system/cache.vue"),
                meta: {
                    title: "缓存管理",
                    icon: "redis",
                    affix: false,
                },
            },
            {
                path: "app",
                name: "dev-system-app",
                component: () => import("@/views/dev/system/app.vue"),
                meta: {
                    title: "应用管理",
                    icon: "project",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/admin-log",
        name: "dev-admin-log",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/admin-log/action-log",
        meta: {
            title: "系统日志",
            icon: "system",
            parent: "dev",
        },
        children: [
            {
                path: "action-log",
                name: "dev-system-action-log",
                component: () => import("@/views/dev/log/system/action-log.vue"),
                meta: {
                    title: "管理日志",
                    icon: "admin-log",
                },
            },
        ],
    },
    {
        path: "/dev/exception",
        name: "dev-exception",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/exception/wx",
        meta: {
            title: "异常中心",
            icon: "exception",
            parent: "dev",
            group: 512,
        },
        children: [
            {
                path: "wx",
                name: "dev-exception-wx",
                component: () => import("@/views/dev/exception/wx.vue"),
                meta: {
                    title: "微信异常",
                    icon: "wx-exception",
                },
            },
        ],
    },
];
